// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2PW_Y","editButton":"styles_editButton__c4_ew","deleteButton":"styles_deleteButton__3tbcW"};